(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function setupHeader(header) {
    if (!header || header.dataset.sunnierHeaderReady === 'true') return;
    header.dataset.sunnierHeaderReady = 'true';

    var menuToggle = qs(header, '[data-sunnier-menu-toggle]');
    var menuDrawer = qs(header, '[data-sunnier-menu-drawer]');
    var menuOverlay = qs(header, '[data-sunnier-menu-overlay]');
    var searchToggle = qs(header, '[data-sunnier-search-toggle]');
    var searchPanel = qs(header, '[data-sunnier-search-panel]');
    var searchInput = searchPanel ? qs(searchPanel, 'input[type="search"]') : null;
    var sticky = qs(header, '[data-sunnier-sticky]');
    var spacer = qs(header, '[data-sunnier-sticky-spacer]');
    var topBar = qs(header, '.sunnier-header__top');
    var mainBar = qs(header, '.sunnier-header__main');
    var navBar = qs(header, '.sunnier-header__nav--desktop');
    var mobileQuery = window.matchMedia('(max-width: 900px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;
    var lastScrollY = window.scrollY || 0;
    var hideOffset = 80;
    var directionThreshold = 6;

    function measureStickyHeight() {
      if (!sticky) return 0;

      var mainHeight = mainBar ? mainBar.offsetHeight : 0;
      var navHeight = 0;
      var searchHeight = 0;

      if (!mobileQuery.matches && navBar) {
        navHeight = navBar.offsetHeight;
      }

      if (mobileQuery.matches && header.classList.contains('is-search-open') && searchPanel) {
        searchHeight = searchPanel.offsetHeight;
      }

      return mainHeight + navHeight + searchHeight;
    }

    function syncFixedNav() {
      if (!sticky || !spacer) return;

      var menuOpen = header.classList.contains('is-menu-open');
      var searchOpen = header.classList.contains('is-search-open');
      var topHeight = topBar ? topBar.offsetHeight : 0;
      var stickyHeight = measureStickyHeight();
      var scrollY = window.scrollY || 0;
      var stickyTop = menuOpen ? 0 : Math.max(0, topHeight - scrollY);
      var delta = scrollY - lastScrollY;
      var nearTop = scrollY <= hideOffset;
      var shouldHide = false;

      if (!menuOpen && !searchOpen && !nearTop) {
        if (delta > directionThreshold) {
          shouldHide = true;
        } else if (delta < -directionThreshold) {
          shouldHide = false;
        } else {
          shouldHide = header.classList.contains('is-nav-hidden');
        }
      }

      header.style.setProperty('--sunnier-main-height', (mainBar ? mainBar.offsetHeight : 56) + 'px');
      header.style.setProperty('--sunnier-sticky-height', stickyHeight + 'px');
      header.style.setProperty('--sunnier-sticky-top', stickyTop + 'px');
      spacer.style.display = 'block';
      spacer.style.height = Math.max(stickyHeight, 1) + 'px';
      spacer.style.minHeight = Math.max(stickyHeight, 1) + 'px';
      header.classList.toggle('is-nav-pinned', stickyTop === 0);
      header.classList.toggle('is-nav-hidden', shouldHide);

      lastScrollY = scrollY;
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncFixedNav();
      });
    }

    function setMenuOpen(open) {
      header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('sunnier-menu-open', open);
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }
      if (menuDrawer) menuDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (menuOverlay) {
        if (open) menuOverlay.removeAttribute('hidden');
        else menuOverlay.setAttribute('hidden', '');
      }
      if (open) header.classList.remove('is-nav-hidden');
      syncFixedNav();
    }

    function setSearchOpen(open) {
      header.classList.toggle('is-search-open', open);
      if (searchToggle) searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (searchPanel) searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open && searchInput) {
        window.setTimeout(function () {
          searchInput.focus();
        }, 10);
      }
      if (open) header.classList.remove('is-nav-hidden');
      requestSync();
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var next = !header.classList.contains('is-menu-open');
        setMenuOpen(next);
        if (next) setSearchOpen(false);
      });
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', function () {
        setMenuOpen(false);
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var next = !header.classList.contains('is-search-open');
        setSearchOpen(next);
        if (next) setMenuOpen(false);
      });
    }

    header.querySelectorAll('[data-sunnier-menu-drawer] a').forEach(function (link) {
      link.addEventListener('click', function () {
        setMenuOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setMenuOpen(false);
      setSearchOpen(false);
    });

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', function () {
      if (!mobileQuery.matches) {
        setMenuOpen(false);
        setSearchOpen(false);
      }
      setupTopTicker();
      requestSync();
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', function () {
        setupTopTicker();
        requestSync();
      });
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(function () {
        setupTopTicker();
        requestSync();
      });
    }

    if (typeof ResizeObserver !== 'undefined' && sticky) {
      var resizeObserver = new ResizeObserver(requestSync);
      resizeObserver.observe(sticky);
      if (topBar) resizeObserver.observe(topBar);
    }

    function londonHour() {
      var timeZone = (topBar && topBar.getAttribute('data-sunnier-call-tz')) || 'Europe/London';
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: timeZone,
          hour: '2-digit',
          hourCycle: 'h23'
        }).formatToParts(new Date());
        var hourPart = parts.find(function (part) {
          return part.type === 'hour';
        });
        return hourPart ? parseInt(hourPart.value, 10) : new Date().getHours();
      } catch (error) {
        return new Date().getHours();
      }
    }

    function isCallHours() {
      if (!topBar) return false;
      var start = parseInt(topBar.getAttribute('data-sunnier-call-start') || '9', 10);
      var end = parseInt(topBar.getAttribute('data-sunnier-call-end') || '16', 10);
      var hour = londonHour();
      return hour >= start && hour < end;
    }

    function clearTopTicker() {
      if (header._sunnierTickerTimer) {
        window.clearTimeout(header._sunnierTickerTimer);
        header._sunnierTickerTimer = null;
      }
    }

    function setTickerItem(item, state) {
      if (!item) return;
      item.classList.toggle('is-active', state === 'active');
      item.classList.toggle('is-exit', state === 'exit');
      item.classList.toggle('is-enter', state === 'enter');
      if (state === 'active' || state === 'enter' || state === 'exit') {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', '');
      }
    }

    function resetTopTicker() {
      if (!topBar) return;
      var brand = qs(topBar, '[data-ticker-item="brand"]');
      var phone = qs(topBar, '[data-ticker-item="phone"]');
      topBar.classList.remove('is-rotating');
      setTickerItem(brand, 'active');
      setTickerItem(phone, 'hidden');
    }

    function setupTopTicker() {
      if (!topBar) return;
      var ticker = qs(topBar, '[data-sunnier-ticker]');
      var brand = qs(topBar, '[data-ticker-item="brand"]');
      var phone = qs(topBar, '[data-ticker-item="phone"]');
      if (!ticker || !brand || !phone) return;

      var shouldRotate = mobileQuery.matches && isCallHours();
      if (!shouldRotate) {
        clearTopTicker();
        resetTopTicker();
        return;
      }

      if (topBar.classList.contains('is-rotating') && header._sunnierTickerTimer) {
        return;
      }

      clearTopTicker();
      topBar.classList.add('is-rotating');
      setTickerItem(brand, 'active');
      setTickerItem(phone, 'hidden');

      var showingBrand = true;
      var slideMs = reduceMotion.matches ? 0 : 420;
      var holdMs = 4000;

      function swap() {
        if (!mobileQuery.matches || !isCallHours()) {
          resetTopTicker();
          return;
        }

        var outgoing = showingBrand ? brand : phone;
        var incoming = showingBrand ? phone : brand;

        setTickerItem(outgoing, 'exit');
        setTickerItem(incoming, 'enter');
        if (incoming) void incoming.offsetWidth;
        setTickerItem(incoming, 'active');

        header._sunnierTickerTimer = window.setTimeout(function () {
          if (outgoing && !outgoing.classList.contains('is-active')) {
            setTickerItem(outgoing, 'hidden');
          }
          showingBrand = !showingBrand;
          header._sunnierTickerTimer = window.setTimeout(swap, holdMs);
        }, slideMs);
      }

      header._sunnierTickerTimer = window.setTimeout(swap, holdMs);
    }

    setupTopTicker();
    syncFixedNav();
    window.setTimeout(syncFixedNav, 100);
    if (header._sunnierHoursTimer) window.clearInterval(header._sunnierHoursTimer);
    header._sunnierHoursTimer = window.setInterval(setupTopTicker, 60000);
  }

  function init() {
    document.querySelectorAll('.sunnier-header').forEach(setupHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target && event.target.querySelector
      ? event.target.querySelector('.sunnier-header')
      : null;
    if (header) {
      header.dataset.sunnierHeaderReady = 'false';
      setupHeader(header);
    }
  });
})();
